/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    // 满意度调研模板保存
    SaveSatisfactionSurveyTemplate ({ commit }, data) {
        return axios.post(http + '/Report/save_muban', data).then(res => {
            return res.data
        })
    },
    // 满意度调研模板列表
    SatisfactionSurveyTemplateListShow ({ commit }, data) {
        return axios.post(http + '/Report/muban_list', data).then(res => {
            return res.data
        })
    },
    // 满意度调研模板详情
    ShowSurveyTemplateDetail ({ commit }, data) {
        return axios.post(http + '/Report/muban_detail', data).then(res => {
            return res.data
        })
    },
    // 满意度调研模板删除
    DelSatisfactionSurveyTemplate({ commit }, data) {
        return axios.post(http + '/Report/muban_delete', data).then(res => {
            return res.data
        })
    }
    // 用户名登录
    // NoticeAdministrationListShow({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/show', data).then(res => {
    //         return res.data
    //     })
    // },
    // AddNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/add', data).then(res => {
    //         return res.data
    //     })
    // },
    // DeleteNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/delete', data).then(res => {
    //         return res.data
    //     })
    // }
};

const SatisfactionSurveyTemplateModule = {
    state,
    getters,
    actions,
    mutations
}
export default SatisfactionSurveyTemplateModule
